module.exports = __webpack_public_path__ + "static/other/en-AU.cd4926a1.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/lingual/en-AU.json
// module id = 1860
// module chunks = 0